import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcPaid } from "react-icons/fc";
import { BsCheck2Square } from "react-icons/bs";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";

const KryzenOrderView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/pmg/cf-orders/cf-order/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelOrderAcceptance = (Id) => {
    performRequest("PATCH", `/pmg/cf-orders/update-cf-order/${Id}`, {
      status: "accepted",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Order status updated successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPaid className="fs-2  me-1" /> View Order
                </h2>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="table-responsive">
                  <table className="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specification</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td>Photo</td>
                          <td>
                            {data?.pmg_accessory ? (
                              <img
                                src={data?.pmg_accessory?.photo}
                                alt={data?.pmg_accessory?.photo}
                                width={100}
                              />
                            ) : (
                              <img
                                src={data?.pmg_plant?.agronomyWikiUpdate?.image}
                                alt={data?.pmg_plant?.agronomyWikiUpdate?.image}
                                width={100}
                              />
                            )}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Order Id</td>
                          <td>
                            <b>{(data?.orderID || "N/A")?.toUpperCase()}</b>
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product</td>
                          <td>
                            {data?.pmg_accessory
                              ? data?.pmg_accessory?.name
                              : data?.pmg_plant?.agronomyWikiUpdate?.name}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product SKU</td>
                          <td>
                            <b>
                              {data?.pmg_accessory
                                ? data?.pmg_accessory?.accSKU
                                : data?.pmg_plant?.plantSKU}
                            </b>
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Payment details</td>
                          <td>
                            {(
                              data?.paymentDetails?.time || "N/A"
                            )?.toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Shipping Address</td>
                          <td>
                            {`${data?.shippingAddress?.address?.toUpperCase()} , ${data?.shippingAddress?.city?.toUpperCase()} , ${data?.shippingAddress?.state?.toUpperCase()} , ${data?.shippingAddress?.pincode?.toUpperCase()}`}{" "}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Quantity</td>
                          <td>{(data?.quantity || "N/A")?.toUpperCase()}</td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Total Amount</td>
                          <td>
                            ₹{(data?.totalAmount || "N/A")?.toUpperCase()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    {data?.orderType?.endsWith("to kryzen") && (
                      <button
                        className="btn mx-1 mt-2 btn-primary"
                        disabled={data?.status !== "pending"}
                        onClick={() => handelOrderAcceptance(data?.id)}
                      >
                        <BsCheck2Square className="fs-2 me-2" />
                        ACCEPT ORDER
                      </button>
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default KryzenOrderView;
